<template>
    <div class="pt-3 pl-5 pr-5">
        <div class="row w-full mb-3 justify-between flex" style="align-items: center">
            <h1 class="title">Location Risk</h1>
            <div class="cardbody">
                <div class="flex flex-row-reverse items-center">
                    <div class="flex flex-row-reverse items-center">
                        <button class="flex" @click="filterOpen" :class="tenantsSelect.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'">
                            <img v-if="tenantsSelect.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
                            <img v-else src="@/assets/filter.svg" class="filterIcon" />
                            Filters
                        </button>
                    </div>
                    <!-- <div class="text-center">
                        <button class="btnprimary mr-2" @click="showPopUp()">Add</button>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="mt-3 text-xs">
            Identify, assess, and manage risks by keeping your organizational structure up to date. Add new locations, update details, and maintain alignment across the organization to reduce operational and structural risks.
        </div>

        
        <div>
            <newTable :tableRowData="tenantsSelect" :headersData="headers" :openPopup="false" :navigate="true" :loadData="dataLoading"></newTable>
            <div v-if="toolTipActive">
                <tool-tip :tipText="toolTipText"></tool-tip>
            </div>
        </div>
        
    </div>
</template>
<style scoped>
.ellipsis-container {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required,helpers,requiredIf, email } from '@vuelidate/validators';
const numeric = helpers.regex(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/i);
import popup from '@/components/popup.vue';
import useVuelidate from '@vuelidate/core';
import dropdown from '@/components/dropdown.vue';
// import { toast } from '../../main';
const alphabet = helpers.regex(/^[a-zA-Z]+$/);
import newTable from '@/components/newTable.vue';
import { zip } from 'lodash';
import { toast, emitter } from '@/main';
import toolTip from '@/components/toolTip.vue'

export default defineComponent({
    data(): any {
        return {
            v$: useVuelidate(),
            showFilters: false,
            popUp: false,
            users:[],
            toolTipActive : false,
            toolTipText : '',
            dataLoading:true,
            optionsUserArray:[],
            tenantsSelect: [],
            objToBeModified: {},
            selectedCategory: [],
            regionDataArray:[],
            headers: ['displayName', 'legalName', 'orgType','city','country','region','owner'],
            regionList:[],
            businesss: {
                companyName: '',
                companyDisplayName: '',
                industrySectorName: '',
                emailAddress: '',
                phoneNumber: '',
                addressLineOne: '',
                addressLineTwo: '',
                entityType: '',
                city: '',
                state: '',
                zipCode: '',
                country: ''
            },
            countriesStatesCities: [
                {
                    CountryName: 'India',
                    States: [
                        {
                            StateName: 'Maharashtra',
                            Cities: ['Pune', 'Nagpur', 'Mumbai']
                        },
                        {
                            StateName: 'Kerala',
                            Cities: ['Kochi', 'Munnar']
                        },
                        {
                            StateName: 'Telangana',
                            Cities: ['Hyderabad', 'Nizamabad','Warangal']
                        },
                        {
                            StateName: 'Andhra Pradesh',
                            Cities: ['Vijayawada', 'Vizag','Rajamundry']
                        }
                    ]
                },
                {
                    CountryName: 'Australia',
                    States: [
                        {
                            StateName: 'Aukland',
                            Cities: ['GlenField', 'Henderson', 'MilFord']
                        },
                        {
                            StateName: 'Melbourne',
                            Cities: ['Melbourne', 'South Oakleigh']
                        }
                    ]
                }
            ],

            orgType:[
                {
                    id: 1,
                    value: 'Primary'
                },
                {
                    id: 2,
                    value: 'Subsidiary'
                },
                {
                    id: 3,
                    value: 'Branch'
                },
            ]
        };
    },
    components: {
        newTable,
        popup,
        dropdown,
        toolTip
    },
    validations() {
        return {
            businesss: {
                companyName: { required },
                companyDisplayName: { required },
                industrySectorName: { required },
                emailAddress: { required, email },
                phoneNumber: { required, numeric },
                addressLineOne: { required },
                entityType: { required },
                city: { required,alphabet },
                state: { required, alphabet },
                country: { required, alphabet },
                zipCode: { required, zip }
            },
        }
    },
    async mounted() {
        this.dataLoading = true;
        await this.getAllRegions();
        await this.getAllUsers();
        await this.getAllBusinessEntities();
        this.dataLoading = false;

        emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });
    },
    methods: {
        filterOpen() {
            this.showFilters = !this.showFilters;
            emitter.emit('visible', this.showFilters);
        },
        async getAllUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.optionsUserArray.push({ label: this.users[i].name, value: this.users[i]._id });
            }
        },
        async getAllRegions(){
			this.actualRegion ='';
            let entities:any = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                entities = res.data;
             })
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/regions/getall`).then((res: any) => {
			this.regionDataArray = res.data;
            this.regionDataArray.map((region : any)=>{
            let a = { value:region._id, label:region.region }
                    this.regionList.push(a);
                })
            });
		 },
        async getAllBusinessEntities() {
            // emitter.emit('visible', false);
            // this.showFilters = false;
            let entityId = 20001;
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((result: any) => {
                result.data.map((object: any)=>{
                    object.entityId = 20001
                    const mainName = this.optionsUserArray.find((obj: any) => { 
                        return obj.value == object.owner
                    });
                    let entityDetails=this.regionList.find((obj:any)=>{
                        return obj.value == object.region
                    }); 
                    let industrySectorName:any = (object.industrySectorName==''||object.industrySectorName==undefined)?'N/A':object.industrySectorName;
                    object.industrySectorName = industrySectorName
                    const owner = mainName ? mainName.label : 'N/A';
                    let entityName=entityDetails?entityDetails.label:'N/A'
                    this.tenantsSelect.push({
                        _id: object._id,
                        entityId: 20001,
                        'displayName': object.entityDisplayName ? object.entityDisplayName: 'N/A',
                        'legalName':object.entityName? object.entityName: 'N/A',
                        'orgType':object.entityType?this.orgType.find((obj: any)=>obj.id == object.entityType).value: 'N/A',
                        country:object.country?object.country:'N/A',
                        city:object.city?object.city:'N/A',
                        owner: owner,
                        'region':entityName,
                    }

                    )
                    
                })
                // this.$store.dispatch('updateDotsLoading', false);
            });
        }
    }
});
</script>



